import { ITextInput } from './Input'

const countDecimals = (step: number): number =>
  String(step).match(/\.(\d+)$/)?.[1]?.length || 0

export const formatInputValue = (
  value: string,
  type: ITextInput['type'],
  step: number,
): string => {
  if (type !== 'currency' || value === '') {
    return value
  }
  return Number(value).toFixed(countDecimals(step))
}
